import React from 'react';

/**
 * The visual/graphical scene that fills the middle of the Batucada UI —
 * background image + instrument name overlays that pulse when playing.
 * Extracted from BatucadaRio.jsx.
 */
export const InstrumentVisual = ({ selectedInstrument, isPlaying }) => {
  const instruments = [
    { name: 'SURDO', x: '25%', y: '20%' },
    { name: 'CAIXA', x: '50%', y: '15%' },
    { name: 'REPINIQUE', x: '75%', y: '20%' },
    { name: 'TAMBORIM', x: '20%', y: '50%' },
    { name: 'AGOGO', x: '80%', y: '50%' },
    { name: 'CUICA', x: '35%', y: '70%' },
    { name: 'PANDEIRO', x: '65%', y: '70%' },
  ];

  return (
    <div className="flex-1 relative overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1651463245475-bbd8c3ff87f2?w=1920&q=80)',
        }}
      />
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/60" />

      {/* Title */}
      <div className="absolute top-6 right-8 text-right z-10">
        <h1
          className="text-4xl text-white font-bold tracking-tight"
          style={{ fontFamily: 'cursive', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}
        >
          Brasilian Grooves!
        </h1>
        <p className="text-gray-300 text-sm mt-1">By Mestre Curtis</p>
      </div>

      {/* Instrument Labels */}
      {instruments.map((inst) => (
        <div
          key={inst.name}
          className={`absolute transform -translate-x-1/2 -translate-y-1/2 text-center transition-all duration-300
            ${isPlaying ? 'scale-110' : ''}`}
          style={{ left: inst.x, top: inst.y }}
        >
          <div
            className={`text-white text-sm font-bold tracking-widest ${isPlaying ? 'text-amber-300' : ''}`}
            style={{ textShadow: '1px 1px 2px rgba(0,0,0,0.8)' }}
          >
            {inst.name}
          </div>
        </div>
      ))}

      {/* Currently Loaded Instrument Indicator */}
      {selectedInstrument && (
        <div className="absolute bottom-4 left-4 bg-black/70 backdrop-blur-sm rounded-lg px-4 py-2 z-10">
          <p className="text-amber-400 text-sm font-medium">{selectedInstrument.name}</p>
          <p className="text-gray-400 text-xs">{selectedInstrument.sample_count || 0} samples loaded</p>
        </div>
      )}
    </div>
  );
};

export default InstrumentVisual;
